"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setQueue = setQueue;
exports.setPending = setPending;
exports.setEnabled = setEnabled;
exports.setOnFailure = setOnFailure;
exports.setOnAllFailure = setOnAllFailure;
exports.setOnParseError = setOnParseError;
exports.enable = enable;
exports.disable = disable;
exports.getFormattedResult = getFormattedResult;
exports.fallbackRequest = fallbackRequest;
exports.getRequestOptions = getRequestOptions;
exports.fetch = fetch;
exports.fetchAndDisable = fetchAndDisable;
exports.addToQueue = addToQueue;
exports.queueFetch = queueFetch;
exports.metaApiEarlyErrorHandler = exports.metaApiErrorHandler = exports.onParseError = exports.onAllFailure = exports.onFailure = exports.isEnabled = exports.pending = exports.queue = exports.MetaRequestParams = exports.UNAUTHED_CODE = exports.FORMAT_ONLY_REQUESTS = exports.CLIENT_TIMEOUT = exports.DOWNSTREAM_TIMEOUT = exports.URI = void 0;

var _immutable = require("immutable");

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

var _q = _interopRequireDefault(require("q"));

var _MetaApiConstants = require("./MetaApiConstants");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var URI = 'crm-meta/v1/meta';
exports.URI = URI;
var DOWNSTREAM_TIMEOUT = 5000;
exports.DOWNSTREAM_TIMEOUT = DOWNSTREAM_TIMEOUT;
var CLIENT_TIMEOUT = 15000;
exports.CLIENT_TIMEOUT = CLIENT_TIMEOUT;
var FORMAT_ONLY_REQUESTS = ['GROUPED_CONTACT_PROPERTIES'];
exports.FORMAT_ONLY_REQUESTS = FORMAT_ONLY_REQUESTS;
var UNAUTHED_CODE = 'EUNAUTHORIZED';
exports.UNAUTHED_CODE = UNAUTHED_CODE;
var MetaRequestParams = (0, _immutable.Record)({
  type: null,
  options: {},
  fallback: _emptyFunction.default,
  deferred: null,
  formatter: _identity.default
}, 'MetaRequestParams');
exports.MetaRequestParams = MetaRequestParams;
var emptySet = (0, _immutable.Set)();
var fromJSTotal = 0;

function fromJSWithTiming(response) {
  var beforeParse = window.performance.now();
  var parsedData = (0, _immutable.fromJS)(response);
  var afterParse = window.performance.now();
  fromJSTotal += afterParse - beforeParse;

  if (window.newrelic) {
    window.newrelic.setCustomAttribute('crmMeta-parse-time', fromJSTotal);
  }

  return parsedData;
}

var queue = emptySet;
exports.queue = queue;
var pending = emptySet;
exports.pending = pending;
var isEnabled = false;
exports.isEnabled = isEnabled;
var onFailure = _emptyFunction.default;
exports.onFailure = onFailure;
var onAllFailure = _emptyFunction.default;
exports.onAllFailure = onAllFailure;
var onParseError = _emptyFunction.default;
exports.onParseError = onParseError;

function setQueue(newQueue) {
  exports.queue = queue = newQueue;
}

function setPending(newPending) {
  exports.pending = pending = newPending;
}

function setEnabled(newEnabled) {
  exports.isEnabled = isEnabled = newEnabled;
}

function setOnFailure(callback) {
  exports.onFailure = onFailure = callback;
}

function setOnAllFailure(callback) {
  exports.onAllFailure = onAllFailure = callback;
}

function setOnParseError(callback) {
  exports.onParseError = onParseError = callback;
}

function enable() {
  exports.isEnabled = isEnabled = true;
}

function disable() {
  exports.isEnabled = isEnabled = false;
}

function getFormattedResult(type, request, result) {
  var formatter = request.formatter;

  if (!formatter) {
    return fromJSWithTiming(result);
  } else if (FORMAT_ONLY_REQUESTS.includes(request.type)) {
    return formatter(result);
  }

  try {
    result = formatter(fromJSWithTiming(result));
  } catch (e) {
    onParseError({
      type: type,
      request: request,
      result: result,
      options: request.options
    });
  }

  return result;
}

function makeFallbackRequest(request) {
  var deferred = request.deferred;
  request.fallback().then(function (response) {
    exports.pending = pending = pending.delete(request);

    try {
      deferred.resolve(getFormattedResult(request.type, request, response));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      onFailure({
        type: request.type,
        request: request,
        response: response
      });
    }
  }, function (error) {
    exports.pending = pending = pending.delete(request);
    deferred.reject(error);
  }).done();
}

function fallbackRequest(requests) {
  if (_immutable.Set.isSet(requests)) {
    requests.forEach(makeFallbackRequest);
  } else {
    makeFallbackRequest(requests);
  }
}

function getRequestOptions(requests) {
  var options = {};
  var requestMap = requests.reduce(function (map, request) {
    options = Object.assign(options, request.options);
    return map.set(request.type, map.get(request.type, (0, _immutable.Set)()).add(request));
  }, (0, _immutable.Map)());
  ['companyId', 'vid', 'dealId', 'ticketId'].forEach(function (objectId) {
    // object ids have to be an int, otherwise the request will 400
    if (options[objectId]) {
      options[objectId] = parseInt(options[objectId], 10);
    }
  });
  options = Object.assign(options, {
    timeoutMillis: DOWNSTREAM_TIMEOUT,
    types: Object.keys(requestMap.toObject())
  });
  return {
    requestMap: requestMap,
    options: options
  };
}

var metaApiErrorHandler = function metaApiErrorHandler() {
  var requestMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var requestStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var error = arguments.length > 3 ? arguments[3] : undefined;
  // eslint-disable-next-line no-console
  console.error(error);
  var isUnauthorized = error && error.errorCode === UNAUTHED_CODE;

  if (isUnauthorized) {
    // if the request is unauthorized we should not make the fallback requests
    (0, _Dispatch.dispatchSafe)(_MetaApiConstants.META_API_FINISHED, _MetaApiConstants.UNAUTHORIZED);
  }

  if (!isUnauthorized) {
    // if it's a general error, still make the fallbacks and update the store state
    requestMap.forEach(fallbackRequest);
    (0, _Dispatch.dispatchSafe)(_MetaApiConstants.META_API_FINISHED, _MetaApiConstants.ERROR);
  }

  var requestEnd = window.performance.now();

  if (window.newrelic) {
    window.newrelic.setCustomAttribute('crmMeta-error-time', requestEnd - requestStart);
  }

  if (error && !isUnauthorized) {
    // if the user isn't authorized the request technically succeeded and
    // we shouldn't report a failure, so only call this when we are authorized
    onAllFailure({
      type: error.errorCode,
      options: options
    });
  }
};

exports.metaApiErrorHandler = metaApiErrorHandler;

var metaApiEarlyErrorHandler = function metaApiEarlyErrorHandler(reject, err) {
  if (err.status === 403) {
    if (window.newrelic) {
      // probably useful to know how often we're accessing unauthorized records
      window.newrelic.setCustomAttribute('crmMeta-unauthorized-access', true);
    }

    err.errorCode = UNAUTHED_CODE;
  }

  reject(err);
};

exports.metaApiEarlyErrorHandler = metaApiEarlyErrorHandler;

function fetch() {
  var originalQueue = queue;
  exports.pending = pending = pending.union(queue);
  exports.queue = queue = emptySet;

  if (originalQueue.isEmpty()) {
    return;
  }

  if (originalQueue.size === 1) {
    var request = originalQueue.first(); // eslint-disable-next-line no-console

    console.info("crm-meta: Only " + request.type + ", falling back", request.options);
    fallbackRequest(request);
    return;
  }

  var _getRequestOptions = getRequestOptions(originalQueue),
      requestMap = _getRequestOptions.requestMap,
      options = _getRequestOptions.options;

  var requestStart = window.performance.now();
  var requestOptions = {
    timeout: CLIENT_TIMEOUT,
    type: _HTTPVerbs.POST
  };
  var resultPromise;
  var earlyMetaRequest = window.quickFetch && window.quickFetch.getRequestStateByName('meta');

  if (earlyMetaRequest) {
    resultPromise = new _q.default.Promise(function (resolve, reject) {
      earlyMetaRequest.whenFinished(function (result) {
        resolve(result);
      });
      earlyMetaRequest.onError(function (err) {
        return metaApiEarlyErrorHandler(reject, err);
      });
    });

    if (window.newrelic) {
      window.newrelic.setCustomAttribute('crmMeta-early-request-used', Boolean(earlyMetaRequest.finished));
    }
  } else {
    resultPromise = (0, _ImmutableAPI.send)(requestOptions, URI, options, _identity.default);
  }

  resultPromise.then(function (results) {
    var requestEnd = window.performance.now();

    if (window.newrelic && !earlyMetaRequest) {
      window.newrelic.setCustomAttribute('crmMeta-success-time', requestEnd - requestStart);
    }

    (0, _Dispatch.dispatchSafe)(_MetaApiConstants.META_API_FINISHED, _MetaApiConstants.SUCCESS);

    if (earlyMetaRequest) {
      // null out the early requester so on next navigation
      // we don't try to use an old XHR
      window.quickFetch.removeEarlyRequest('meta');
    }

    var data = results.data;
    var failed = results.failed;
    var shortCircuited = results.shortCircuited;
    var timedOut = results.timedOut;
    requestMap.forEach(function (requests, type) {
      requests.forEach(function (request) {
        var response = data[type];

        if (response || response === null) {
          try {
            request.deferred.resolve(getFormattedResult(type, request, response));
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            fallbackRequest(request);
            onFailure({
              type: type,
              request: request,
              response: response,
              options: request.options
            });
            return;
          }

          exports.pending = pending = pending.delete(request);
          return;
        }

        fallbackRequest(request);
        var requestFailureType;

        if (failed.indexOf(type) >= 0) {
          requestFailureType = 'failed';
        } else if (shortCircuited.indexOf(type) >= 0) {
          requestFailureType = 'shortCircuited';
        } else if (timedOut.indexOf(type) >= 0) {
          requestFailureType = 'timedOut';
        }

        onFailure({
          type: type,
          requestFailureType: requestFailureType,
          request: request,
          response: response,
          options: request.options
        });
      });
    });
  }, function (err) {
    return metaApiErrorHandler(requestMap, requestStart, options, err);
  });
}

function fetchAndDisable() {
  // It currently takes 2 ticks to gather all of the initial reqs
  setTimeout(function () {
    setTimeout(function () {
      fetch();
      disable();
    }, 0);
  }, 0);
}

function addToQueue(request, callback) {
  if (queue.has(request) || pending.has(request)) {
    return;
  }

  exports.queue = queue = queue.add(request);
  callback();
}

function queueFetch(type, fallback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var formatter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _identity.default;

  if (!isEnabled && fallback) {
    return fallback(options).then(formatter);
  }

  var deferred = (0, _defer.default)();
  addToQueue(MetaRequestParams({
    type: type,
    fallback: fallback,
    deferred: deferred,
    options: options,
    formatter: formatter
  }), fetchAndDisable);
  return deferred.promise;
}